/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseBaseInfo } from './ResponseBaseInfo';
import {
    ResponseBaseInfoFromJSON,
    ResponseBaseInfoFromJSONTyped,
    ResponseBaseInfoToJSON,
    ResponseBaseInfoToJSONTyped,
} from './ResponseBaseInfo';

/**
 * 
 * @export
 * @interface ResponseLoginResponse
 */
export interface ResponseLoginResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLoginResponse
     */
    approval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLoginResponse
     */
    baseFlg?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponseLoginResponse
     */
    baseId?: number;
    /**
     * 
     * @type {Array<ResponseBaseInfo>}
     * @memberof ResponseLoginResponse
     */
    baseInfo?: Array<ResponseBaseInfo>;
    /**
     * 
     * @type {string}
     * @memberof ResponseLoginResponse
     */
    category?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLoginResponse
     */
    commitment?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponseLoginResponse
     */
    createdAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLoginResponse
     */
    deposit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponseLoginResponse
     */
    driverName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseLoginResponse
     */
    firstName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLoginResponse
     */
    flg?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponseLoginResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseLoginResponse
     */
    introducer?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLoginResponse
     */
    isInitialPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLoginResponse
     */
    isLocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLoginResponse
     */
    isSuperAdmin?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ResponseLoginResponse
     */
    isOperationLogViewer?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ResponseLoginResponse
     */
    largeProduct?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponseLoginResponse
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseLoginResponse
     */
    lineId?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseLoginResponse
     */
    lineName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseLoginResponse
     */
    loginRetriedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseLoginResponse
     */
    loginHistoryId?: number;
    /**
     * 認証トークン（Authorizationヘッダで使用）
     * @type {string}
     * @memberof ResponseLoginResponse
     */
    token?: string;
    /**
     *
     * @type {string}
     * @memberof ResponseLoginResponse
     */
    mail?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseLoginResponse
     */
    monthlyCharge?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLoginResponse
     */
    noSticker?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponseLoginResponse
     */
    permissionId?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseLoginResponse
     */
    shippingNum?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseLoginResponse
     */
    shopName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseLoginResponse
     */
    tenantId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseLoginResponse
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ResponseLoginResponse interface.
 */
export function instanceOfResponseLoginResponse(value: object): value is ResponseLoginResponse {
    return true;
}

export function ResponseLoginResponseFromJSON(json: any): ResponseLoginResponse {
    return ResponseLoginResponseFromJSONTyped(json, false);
}

export function ResponseLoginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseLoginResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'approval': json['approval'] == null ? undefined : json['approval'],
        'baseFlg': json['base_flg'] == null ? undefined : json['base_flg'],
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'baseInfo': json['base_info'] == null ? undefined : ((json['base_info'] as Array<any>).map(ResponseBaseInfoFromJSON)),
        'category': json['category'] == null ? undefined : json['category'],
        'commitment': json['commitment'] == null ? undefined : json['commitment'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'deposit': json['deposit'] == null ? undefined : json['deposit'],
        'driverName': json['driver_name'] == null ? undefined : json['driver_name'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'flg': json['flg'] == null ? undefined : json['flg'],
        'id': json['id'] == null ? undefined : json['id'],
        'introducer': json['introducer'] == null ? undefined : json['introducer'],
        'isInitialPassword': json['is_initial_password'] == null ? undefined : json['is_initial_password'],
        'isLocked': json['is_locked'] == null ? undefined : json['is_locked'],
        'isSuperAdmin': json['is_super_admin'] == null ? undefined : json['is_super_admin'],
        'isOperationLogViewer': json['is_operation_log_viewer'] == null ? undefined : json['is_operation_log_viewer'],
        'largeProduct': json['large_product'] == null ? undefined : json['large_product'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'lineId': json['line_id'] == null ? undefined : json['line_id'],
        'lineName': json['line_name'] == null ? undefined : json['line_name'],
        'loginRetriedCount': json['login_retried_count'] == null ? undefined : json['login_retried_count'],
        'loginHistoryId': json['loginHistoryId'] == null ? undefined : json['loginHistoryId'],
        'token': json['token'] == null ? undefined : json['token'],
        'mail': json['mail'] == null ? undefined : json['mail'],
        'monthlyCharge': json['monthly_charge'] == null ? undefined : json['monthly_charge'],
        'noSticker': json['no_sticker'] == null ? undefined : json['no_sticker'],
        'permissionId': json['permission_id'] == null ? undefined : json['permission_id'],
        'shippingNum': json['shipping_num'] == null ? undefined : json['shipping_num'],
        'shopName': json['shop_name'] == null ? undefined : json['shop_name'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ResponseLoginResponseToJSON(json: any): ResponseLoginResponse {
    return ResponseLoginResponseToJSONTyped(json, false);
}

export function ResponseLoginResponseToJSONTyped(value?: ResponseLoginResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approval': value['approval'],
        'base_flg': value['baseFlg'],
        'base_id': value['baseId'],
        'base_info': value['baseInfo'] == null ? undefined : ((value['baseInfo'] as Array<any>).map(ResponseBaseInfoToJSON)),
        'category': value['category'],
        'commitment': value['commitment'],
        'created_at': value['createdAt'],
        'deposit': value['deposit'],
        'driver_name': value['driverName'],
        'first_name': value['firstName'],
        'flg': value['flg'],
        'id': value['id'],
        'introducer': value['introducer'],
        'is_initial_password': value['isInitialPassword'],
        'is_locked': value['isLocked'],
        'is_super_admin': value['isSuperAdmin'],
        'is_operation_log_viewer': value['isOperationLogViewer'],
        'large_product': value['largeProduct'],
        'last_name': value['lastName'],
        'line_id': value['lineId'],
        'line_name': value['lineName'],
        'login_retried_count': value['loginRetriedCount'],
        'loginHistoryId': value['loginHistoryId'],
        'token': value['token'],
        'mail': value['mail'],
        'monthly_charge': value['monthlyCharge'],
        'no_sticker': value['noSticker'],
        'permission_id': value['permissionId'],
        'shipping_num': value['shippingNum'],
        'shop_name': value['shopName'],
        'tenant_id': value['tenantId'],
        'updated_at': value['updatedAt'],
    };
}

